<template>
  <ul class="nav navbar-nav navbar-right">
    <!-- <router-link to="/org/inscricao" tag="li"><a>Inscrição</a></router-link> -->
    <!-- <router-link to="/org/lista-inscritos" tag="li"><a>Lista Inscritos</a></router-link> -->
    <!-- <router-link to="/org/estatistica" tag="li"><a>Estatística</a></router-link> -->
    <li class="dropdown">
			<a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">Controlos <span class="caret"></span></a>
			<ul class="dropdown-menu" role="menu">
        <router-link to="/org/controlo1" tag="li"><a>Controlo 1</a></router-link>
        <router-link to="/org/controlo2" tag="li"><a>Controlo 2</a></router-link>
			</ul>
		</li>
  </ul>
</template>

<script>
export default {
  name: 'OrgNav'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Nav.vue?a7ecd6b6